import { getObjectUtil } from 'packages/src'
import { getCurrentOrCustomerIdProfileSelect } from '../../../profile/redux/selectors/get-current-or-customer-id'
import getReduxSelector from '../get'
import { getDataPathReduxUtil } from '../../utils/get-data-path'
import getInstancesFromMapReduxUtil from '../../utils/get-instances-from-map'
import getByProfileIdDataPeriodDomainListPathFromDomainPathReduxUtil
  from '../../utils/get-by-profile-id-data-period-domain-list-path-from-domain-path'

function getDomainListByDatePeriodReduxSelector ({
  domainPath,
  datePeriodUnit,
  date
}) {
  return state => {
    const profileId = getCurrentOrCustomerIdProfileSelect(state)
    const domainListPath = getByProfileIdDataPeriodDomainListPathFromDomainPathReduxUtil(
      {
        domainPath,
        datePeriodUnit,
        profileId,
        date
      })
    return getObjectUtil(state, domainListPath)
  }
}

function getDomainListDataByDatePeriodReduxSelector (params) {
  return state => {
    return getDomainListByDatePeriodReduxSelector(params)(state)?.data || []
  }
}

function getDomainListDataInstancesByDatePeriodReduxSelector (params) {
  return state => {
    const domainListData = getDomainListByDatePeriodReduxSelector(params)(
      state)?.data || []
    return getInstancesFromMapReduxUtil(
      getReduxSelector(getDataPathReduxUtil(params.domainPath))(state),
      domainListData
    )
  }
}

export {
  getDomainListByDatePeriodReduxSelector,
  getDomainListDataInstancesByDatePeriodReduxSelector,
  getDomainListDataByDatePeriodReduxSelector
}
